import {
  PickersLayoutContentWrapper,
  PickersLayoutRoot,
  pickersLayoutClasses,
  usePickerLayout,
} from '@mui/x-date-pickers-pro';
import React from 'react';
import useStyles from './styles';

function CustomLayout(props) {
  const { shortcuts, content, actionBar, toolbar } = usePickerLayout(props);
  const { classes } = useStyles();

  return (
    <PickersLayoutRoot className={classes.datePickerPopover} ownerState={props}>
      {shortcuts}
      <PickersLayoutContentWrapper className={pickersLayoutClasses.contentWrapper}>
        {toolbar}
        {content}
      </PickersLayoutContentWrapper>
      {actionBar}
    </PickersLayoutRoot>
  );
}

export default CustomLayout;
